import { useConfiguration } from "@src/hooks/query/useConfiguration";

const useEndOfServiceConfiguration = (): {
  /** In minutes */
  firstWarningDelay: number;
  /** In minutes */
  secondWarningDelay: number;
  /** In minutes */
  thirdWarningDelay: number;
} => {
  const { getConfiguration: c } = useConfiguration();

  const firstWarningDelay = c("_END_OF_SERVICE_DELAY_FIRST_WARNING_", 15);
  const secondWarningDelay = c("_END_OF_SERVICE_DELAY_SECOND_WARNING_", 10);
  const thirdWarningDelay = c("_END_OF_SERVICE_DELAY_THIRD_WARNING_", 5);

  return {
    firstWarningDelay,
    secondWarningDelay,
    thirdWarningDelay,
  };
};

export default useEndOfServiceConfiguration;
